import { Temporal } from '@imago/api-client'
import { GoButton } from "@imago/api-client-for-react"
import { useCare } from '../../api.ts'
import { formatDays, ImagoCare } from '../Care.tsx'
import { useGAHTConsented } from '../FormDialog.tsx'
import { Hello } from "../Hello.tsx"
import { TakeBloodTests } from "./tasks/TakeBloodTests.tsx"
import { DescribeYourExperience } from "./tasks/DescribeYourExperience.tsx"

const FEEDBACK_SURVEY_URL = 'https://forms.gle/LqmF5AWZi1GDQPi58'

export function ReviewGAHT({fullScreen}: {fullScreen?: boolean}) {
	const consented = useGAHTConsented()!
	const ago = Temporal.Now.instant().until(consented)

	const showReview = ago.total('days') < -20

	const Section = fullScreen ? 'main' : 'div'
	const H = fullScreen ? 'h1' : 'h2'

	const care = useCare()

	return <Section>
		{fullScreen ? <Hello/> : <></>}
		<section>
			<H>Your GAHT</H>
			{fullScreen ? <p><strong>Congratulations!</strong></p> : <></>}
			<p>You've started your gender-affirming therapy with Imago <strong>{formatDays(ago)}</strong>.</p>
			{!showReview ? <>
				<p><strong>Soon, we’ll send you a prescription - that you can use in any pharmacy in the European Union.</strong> <i>Note: We’re still working on our app - and this part isn’t finished yet. Our team will assist you through emails until we get it done.</i></p> {/* TODO */}
				<p>Once you've received the prescription, we'd like to ask you to fill out the <strong>shipping feedback survey</strong>. It's very short, it shouldn't take more than a minute.</p>
				<GoButton href={FEEDBACK_SURVEY_URL} target="_blank">Open shipping feedback survey</GoButton>
				{care && !care.nextCharge && !care.terminated ? <>
					<p><strong>Meanwhile, please set up automated payments for the Imago Care:</strong></p>
				</> : <></>}
			</> : <></>}
			<ImagoCare/>
			{!fullScreen && showReview ? <>
				<p>To ensure a smooth process, please perform the treatment review when you have approximately four weeks remaining of your prescription.</p>
				<GoButton className="primary" href="/gaht">Go to treatment review</GoButton>
			</> : <></>}
		</section>
		{!(fullScreen && showReview) ? <></> : <>
			<hr data-total/>
			<section>
				<H>Treatment Review</H>
				<p>To ensure a smooth process, please perform the treatment review when you have approximately four weeks remaining of your prescription.</p>
			</section>
			<hr data-total/>
			<TakeBloodTests/>
			<hr data-total/>
			<DescribeYourExperience/>
			<hr data-total/>
			<section>
				<h2>Next steps</h2>
				<p>After you finish the above steps:</p>
				<ol>
					<li>Our physician will review your results and experiences.</li>
					<li>If deemed necessary, we'll contact you with more questions.</li>
					<li>We’ll send you a prescription - that you can use in any pharmacy in the European Union.</li>
				</ol>
				<p><i>Note: We’re still working on our app - and the next part isn’t finished yet. Our team will assist you through emails until we get it done.</i></p> {/* TODO */}
				<p>Once you've received the prescription, we'd like to ask you to fill out the <strong>shipping feedback survey</strong>. It's very short, it shouldn't take more than a minute.</p>
				<GoButton href={FEEDBACK_SURVEY_URL} target="_blank">Open shipping feedback survey</GoButton>
			</section>
		</>}
	</Section>
}
